import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { paginationClass } from './styles';
import Links from './Links';
import Jumper from './Jumper';
import Simple from './Simple';
import PageSizeList from './PageSizeList';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
import { getDirectionClass } from '../utils/classname';

var DefaultValue = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  layout: ['links'],
  span: 5,
  text: {}
});

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  var _super = _createSuper2(Pagination);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _super.apply(this, arguments);
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          align = _this$props.align,
          layout = _this$props.layout,
          size = _this$props.size,
          style = _this$props.style;
      var rtl = isRTL();
      var className = classnames(paginationClass('_', size, align, rtl && 'rtl'), this.props.className);
      var sectionClassName = paginationClass(getDirectionClass('section'));
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style
        }, getDataset(this.props)), layout.map(function (section, i) {
          switch (section) {
            case 'links':
              return (
                /*#__PURE__*/
                React.createElement(Links, Object.assign({
                  key: section
                }, _this.props))
              );

            case 'list':
              return (
                /*#__PURE__*/
                React.createElement(PageSizeList, Object.assign({
                  key: section
                }, _this.props))
              );

            case 'jumper':
              return (
                /*#__PURE__*/
                React.createElement(Jumper, Object.assign({
                  key: section
                }, _this.props))
              );

            case 'simple':
              return (
                /*#__PURE__*/
                React.createElement(Simple, Object.assign({
                  key: section
                }, _this.props))
              );

            default:
              if (typeof section === 'function') {
                return (
                  /*#__PURE__*/
                  React.createElement("div", {
                    key: i,
                    className: sectionClassName
                  },
                  /*#__PURE__*/
                  React.createElement("span", null, section(_this.props)))
                );
              }

              return null;
          }
        }))
      );
    }
  }]);

  return Pagination;
}(PureComponent);

Pagination.defaultProps = DefaultValue;
export default Pagination;